import React from "react";
import Section from "../../common/Details";
import { useFormikContext } from "formik";
import { generateJobReviewDetails } from "../../../constant/Home/Jobs";
import { useCurrentSelectedData } from "../../../context/CurrentSelectedDataContext";
const Step4 = () => {
  const { currentSelectedData } = useCurrentSelectedData();
  const { values } = useFormikContext();

  return (
    <>
      <Section
        sections={generateJobReviewDetails(currentSelectedData, values)}
        className="p-0"
      />

      <hr className="mt-2" />
    </>
  );
};

export default Step4;
